// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1cd30b77].text--content a {\n  color: var(--magic-text-primary, #292d39);\n  text-decoration: none;\n  font-weight: var(--magic-font-weight-bold, 700);\n}", ""]);
// Exports
module.exports = exports;
